import { LegalTradeMarksPage } from './LegalTradeMarksPage';

export default LegalTradeMarksPage;
